exports.default = {
    cs: {
        currency: 'Kč',
        back: 'zpět',
        close: 'zavřít',
        refresh: 'aktualizovat',
        voucher: {
            code: 'Kód poukazu',
            search: 'najít',
            value: 'Hodnota',
            validTo: 'Platí do',
            receiptNumber: 'Číslo účtenky',
        },
        sell: {
            headline: 'Prodat poukaz',
            help: {
                description: 'Zákazník si kupuje poukaz, který například někomu daruje.',
                steps: {
                    headline: 'Postup:',
                    step1: 'Standardním způsobem prodejte na pokladně.',
                    step2: 'Zadejte do formuláře unikátní kód prodaného poukazu (pozor, nezaměňovat s kódem EAN!)',
                    step3: 'Vyplňte do formuláře číslo účtenky (prodejky)',
                    step4: 'Vyplňte na poukaz dobu platnosti',
                }
            },
            last: {
                headline: 'Poslední prodaný poukaz'
            },
            button: 'Vystavit nový poukaz',
            title: 'Vystavení poukazu'
        },
        apply: {
            headline: 'Zaplatit poukazem',
            help: {
                description: 'Zákazník přišel s dárkovým poukazem, kterým chce zaplatit.',
                steps: {
                    headline: 'Postup:',
                    step1: 'Vyplňte do formuláře unikátní kód poukazu pro ověření platnosti.',
                    step2: 'Pokud ověření proběhlo v pořádku, můžete standardním způsobem provést uplatnění poukazu na pokladně.',
                    step3: 'Jakmile bude prodej na pokladně dokončen, klikněte na "uplatnit", čímž bude poukaz trvale deaktivován.'
                }
            },
            dialog: {
                title: 'Opravdu uplatnit?',
                button: 'uplatnit poukaz',
                message: 'Opravdu uplatnit poukaz {code} v hodnotě {value} Kč?'
            },
            prepareButton: 'Připravit k uplatnění',
            title: {
                step1: 'Uplatnění poukazu - 1. krok'
            }
        },
        processing: {
            headline: 'Rozpracované poukazy',
            empty: 'Žádné rozpracované poukazy',
            button: {
                yes: 'uplatnit',
                no: 'neuplatňovat',
            }
        },
        message: {
            invalidKey: 'Neplatný klíč',
            success: {
                voucherApplied: 'Kód uplatněn',
                voucherActivated: 'Poukaz byl aktivován!',
                voucherPrepared: 'Poukaz byl připraven k uplatnění!'
            },
            voucherInvalid: 'Poukaz není platný',
            voucherDuplicated: 'Poukaz "{code}" již byl vystaven {validFrom}',
            voucherApplyError: 'Došlo k chybě a kód se nepodařilo uplatnit',
            voucherNotFound: 'Poukaz s kódem "{code}" nenalezen',
            voucherLocked: 'Poukaz je již rozpracovaný na jiné pokladně',
            error: 'Chyba: {err}',
            accessDenied: 'Přístup zamítnut'
        }
    },
    sk: {
        currency: '€',
        back: 'späť',
        close: 'zavrieť',
        refresh: 'aktualizovať',
        voucher: {
            code: 'Kód poukazu',
            search: 'nájsť',
            value: 'Hodnota',
            validTo: 'Platí do',
            receiptNumber: 'Číslo predajky',
        },
        sell: {
            headline: 'Predať poukaz',
            help: {
                description: 'Zákazník si kupuje poukaz, ktorý napríklad daruje.',
                steps: {
                    headline: 'Postup:',
                    step1: 'Štandardným spôsobom predajte na pokladni.',
                    step2: 'Zadajte do formulára unikátny kód predaného poukazu (pozor, nezamieňať s EAN kódom!)',
                    step3: 'Vyplňte do formulára číslo predajky',
                    step4: 'Vyplňte na poukaz dobu platnosti!',
                }
            },
            last: {
                headline: 'Posledný predaný poukaz'
            },
            button: 'Vystaviť nový poukaz',
            title: 'Vystavenie poukazu'
        },
        apply: {
            headline: 'Zaplatiť poukazom',
            help: {
                description: 'Zákazník prišiel s darčekovým poukazom, ktorým chce zaplatiť',
                steps: {
                    headline: 'Postup:',
                    step1: 'Vyplňte do formulára unikátny kód poukazu pre overenie platnosti.',
                    step2: 'Ak overenie prebehlo v poriadku, môžete štandardným spôsobom uskutočniť uplatnenie poukazu na pokladni.',
                    step3: 'Akonáhle bude predaj na pokladni dokončený, kliknite na „uplatniť“, čím bude poukaz trvalo deaktivovaný.'
                }
            },
            dialog: {
                title: 'Naozaj uplatniť?',
                button: 'uplatniť poukaz',
                message: 'Naozaj uplatniť poukaz {code} v hodnote {value} €?'
            },
            prepareButton: 'Pripraviť na uplatnenie',
            title: {
                step1: 'Uplatnenie poukazu – 1. krok'
            }
        },
        processing: {
            headline: 'Rozpracované poukazy',
            empty: 'Žiadne rozpracované poukazy',
            button: {
                yes: 'uplatniť',
                no: 'neuplatniť',
            }
        },
        message: {
            invalidKey: 'Neplatný kľúč',
            success: {
                voucherApplied: 'Kód uplatnený',
                voucherActivated: 'Poukaz bol aktivovaný!',
                voucherPrepared: 'Poukaz bol pripravený na uplatnenie!'
            },
            voucherInvalid: 'Poukaz nie je platný',
            voucherDuplicated: 'Voucher "{code}" už bol vystavený {validFrom}',
            voucherApplyError: 'Došlo k chybe a kód se nepodarilo uplatniť',
            voucherNotFound: 'Voucher s kódom "{code}" nenájdený',
            error: 'Chyba: {err}',
            accessDenied: 'Prístup zamietnutý'
        }
    },
    hu: {
        currency: 'Ft',
        back: 'vissza',
        close: 'bezárás',
        refresh: 'frissítés',
        voucher: {
            code: 'kupon kód',
            search: 'megtalálja',
            value: 'érték',
            validTo: '-ig érvényes',
            receiptNumber: 'nyugta száma',
        },
        sell: {
            headline: 'Vásároljon vásárlási utalványt',
            help: {
                description: 'Vásároljon egy vásárlási utalványt, amit ajándékba adhat.',
                steps: {
                    headline: 'Menete:',
                    step1: 'Értékesítés a webáruházban a megszokott módon.',
                    step2: 'Írja be az űrlapba a vásárlási utalvány egyedi kódját (vigyázzon, ne keverje össze az EAN kóddal)',
                    step3: 'Töltse ki az űrlapon a nyugta sorszámát (értékesítési nyugta)',
                    step4: 'Töltse ki az érvényességi időt a vásárlási utalványon',
                }
            },
            last: {
                headline: 'Utoljára eladott vásárlási utalvány'
            },
            button: 'Új vásárlási utalvány kiállítása',
            title: 'Vásárlási utalvány kiállítása'
        },
        apply: {
            headline: 'Fizessen vásárlási utalvánnyal',
            help: {
                description: 'Vásárlási utalvány ellenőrzése, amellyel fizetni szeretne.',
                steps: {
                    headline: 'Menete:',
                    step1: 'Az érvényesség ellenőrzéséhez írja az utalvány egyedi kódját az űrlapba.',
                    step2: 'Ha az ellenőrzés sikeres volt, beválthatja az utalványt a szokásos módon a pénztánál.',
                    step3: 'Miután a termék kiválasztása megtörtént, kattintson a „beváltás” gombra a pénztárnál, hogy az utalvány elfogadásra kerüljön.'
                }
            },
            dialog: {
                title: 'Valóban szeretné felhasználni a vásárlási utalványt?',
                button: 'Vásárlási utalvány beváltása',
                message: 'Valóban beváltja a vásárlási utalványt {code} {value} értékben?'
            },
            prepareButton: 'Készüljön fel az alkalmazásra',
            title: {
                step1: 'Vásárlási utalvány beváltása - 1. lépés'
            }
        },
        processing: {
            headline: 'Folyamatban lévő vásárlási utalványok',
            empty: 'Nincs folyamatban lévő vásárlási utalvány',
            button: {
                yes: 'felhasználható',
                no: 'nem felhasználható',
            }
        },
        message: {
            invalidKey: 'Hibás vásárlási utalvány kód',
            success: {
                voucherApplied: 'Vásárlási utalvány elfogadva',
                voucherActivated: 'A vásárlási utalvány aktiválva lett!',
                voucherPrepared: 'A vásárlási utalvány készen áll a beváltásra!'
            },
            voucherInvalid: 'A vásárlási utalvány nem érvényes',
            voucherDuplicated: 'A vásárlási utalványt "{code}" már létezik {validFrom}',
            voucherApplyError: 'Hiba történt, a vásárlási utalvány kód nem felhasználható',
            voucherNotFound: 'A vásárlási utalvány "{code}" nem található',
            error: 'Hiba: {err}',
            accessDenied: 'Hozzáférés megtagadva'
        }
    },
    pl: {
        currency: 'PLN',
        back: 'powrót',
        close: 'zamknij',
        refresh: 'odśwież',
        voucher: {
            code: 'Kod bonu',
            search: 'szukaj',
            value: 'Waluta',
            validTo: 'Ważny do',
            receiptNumber: 'Numer paragonu',
        },
        sell: {
            headline: 'Sprzedaż bonu',
            help: {
                description: 'Klient kupuje bon, który np. komuś wręcza',
                steps: {
                    headline: 'Proces:',
                    step1: 'Sprzedaj bon przez WAPRO',
                    step2: 'Wpisz do formularza unikalny kod sprzedanego vouchera (uważaj, aby nie pomylić go z kodem EAN!)',
                    step3: 'Wpisz numer paragonu w formularzu (sprzedaż)',
                    step4: 'Uzupełnij okres ważności bonu',
                }
            },
            last: {
                headline: 'Ostatni sprzedany bon'
            },
            button: 'Utwórz nowy bon',
            title: 'Wydanie bonu'
        },
        apply: {
            headline: 'Płatność bonem',
            help: {
                description: 'Klient przynosi bon podarunkowy, którym chce zapłacić',
                steps: {
                    headline: 'Proces:',
                    step1: 'Wypełnij formularz unikalnym kodem kuponu, aby zweryfikować jego ważność',
                    step2: 'Jeśli weryfikacja przebiegła pomyślnie, możesz zrealizować kupon przy kasie w standardowy sposób.',
                    step3: 'Po zakończeniu sprzedaży w kasie kliknij „zrealizuj”, co na stałe dezaktywuje kupon.'
                }
            },
            dialog: {
                title: 'Jesteś pewien, że wszystkie kroki wykonałeś prawidłowo?',
                button: 'zrealizuj bon',
                message: 'Czy na pewno zrealizować bon {code} o wartości {value} PLN?'
            },
            prepareButton: 'Przygotwanie aplikacji',
            title: {
                step1: 'Realizacja bonu - krok 1'
            }
        },
        processing: {
            headline: 'Praca w toku',
            empty: 'brak bonów',
            button: {
                yes: 'zastosuj',
                no: 'odrzuć',
            }
        },
        message: {
            invalidKey: 'Niewłaściwy kod',
            success: {
                voucherApplied: 'Zastosowano kod',
                voucherActivated: 'Bon został aktywowany!',
                voucherPrepared: 'Bon przygotowany do realizacji!'
            },
            voucherInvalid: 'Bon jest nieważny',
            voucherDuplicated: 'Bon "{code}" był już wystawiony {validFrom}',
            voucherApplyError: 'Wystąpił błąd i nie można zastosować kodu',
            voucherNotFound: 'Bonu o numerze "{code}" nie znaleziono',
            voucherLocked: 'Voucher jest już realizowany w innym miejscu',
            error: 'Błąd: {err}',
            accessDenied: 'Brak dostępu'
        }
    }

}
